import React, { useContext } from "react";
import { PostPurchaseContext, PostPurchaseDispatchContext } from "../context/PostPurchaseContext";
import StepContents from "./StepContents";

function PostPurchaseBlock({ block }) {
  const state = useContext(PostPurchaseContext);
  const dispatch = useContext(PostPurchaseDispatchContext);
  
  return (
    <>
      <div type="button" data-after="" className="w-full relative text-center text-white py-[10px] px-[21px] after:content-[attr(data-after)] after:absolute after:border-l-[13px] after:border-r-[13px] after:z-10 after:border-t-[10px] after:border-l-transparent after:border-r-transparent after:border-t-[color:var(--backgroundColor)] bg-[color:var(--backgroundColor)] after:bottom-[1px] after:left-1/2 after:translate-y-full after:-translate-x-1/2 lg:p-8" style={{ '--backgroundColor': `${block.background}` }}>
        <header className="flex items-center gap-4">
          <div className="w-[30px] h-[30px] border-2 text-white font-normal border-current flex rounded-full items-center justify-center lg:text-4xl lg:w-[35px] lg:h-[35px]">{block.id}</div>
          <div className="py-4 font-normal lg:text-4xl">
            {block.title}
          </div>
        </header>
        {state.activeStep === block.id && <StepContents block={block} />}
      </div>
    </>
  );
}

export default PostPurchaseBlock;
